const devilNote = require('./devil')

module.exports = [
  {
    text: `Баэль, Герион, Хутиджин, Молох — всего лишь пешки. Даже повелители слоёв, вроде Зариэль и Маммона, лишь просто более могущественные фигуры на шахматной доске. Архидьяволы могут совершать дерзкие ходы, но только Асмодей лучше всех играет в эту игру`,
    author: `Архимаг Морденкайнен`,
  },
  ...devilNote,
]
